export default theme => ({
  content: {
    minHeight: 'calc(100vh - 80px)',
  },
});
